module.exports = __webpack_public_path__ + "img/img-3.c03ab73f.png";